import {
  type AdditionalPaymentCategoriesRequestQuery,
  type AreasListRequestQuery,
  type ChargeTypesRequestQuery,
  type ContractsRequestQuery,
  type CustomerContractsRequestQuery,
  type CustomersListRequestQuery,
  // type TariffListRequestQuery, // タリフインポート一覧は未実装
  /** システムマスタ設定 */
  type DcUsersRequestQuery,
  type DriverUsersListRequestQuery,
  type ItemUnitsRequestQuery,
  type PackageCategoriesListRequestQuery,
  /** 業務マスタ設定 */
  type PartnersListRequestQuery,
  type PartnerUsersRequestQuery,
  type ShipmentCategoriesListRequestQuery,
  type ShipmentOrdersRequestQuery,
  type SitesListRequestQuery,
  type SubPartnersRequestQuery,
  type ToursRequestQuery,
  type TruckClassesRequestQuery,
  type TruckModelsListRequestQuery,
  type TrucksRequestQuery,
  type TruckTypesRequestQuery
} from '@/libs/api/types'

/**
 * ソートキーとして使用可能なキーの一覧を定義するファイル
 * ここで指定したキーが、テーブル側のソート可能キーと連動します
 *
 * 各モデルの'sort'プロパティから抽出しているため、Front-API間の型の整合性が保たれます
 */

// マスタ以外のソートキー一覧

/** 配送依頼 */

export type ShipmentOrdersSortKey = NonNullable<
  NonNullable<ShipmentOrdersRequestQuery>['sort']
>

export const SHIPMENT_ORDERS_SORT_KEYS: ShipmentOrdersSortKey[] = [
  'shippingDate',
  'shipmentCategory',
  'packageCategory',
  'customer',
  'partner',
  'originSite',
  'destSite',
  'packageCount',
  'quantity',
  'weight',
  'bundleLabel',
  // 登録日の列見出しから並び替えられるようにする（#5285 VOC_PJ-506 D-37）
  'createdAt',
  // #3690 VOC_PJ-577: ステータス・配送依頼No・荷主コード・配車のパートナー/実運送会社/車両番号
  'status',
  'orderNo',
  'customerCode',
  'dispatchPartner',
  'dispatchSubPartner',
  'dispatchTruck'
] as const

/** 運行実績 */

export type ToursSortKey = NonNullable<NonNullable<ToursRequestQuery>['sort']>

export const TOURS_SORT_KEYS: ToursSortKey[] = [
  'startAt',
  'truckCode',
  'contractName',
  'contractType',
  'partnerName',
  'shipmentOrder',
  'customerName'
] as const

// 業務マスタ設定のソートキー一覧

/** パートナー */

export type PartnersSortKey = NonNullable<
  NonNullable<PartnersListRequestQuery>['sort']
>

export const PARTNERS_SORT_KEYS: PartnersSortKey[] = [
  'name',
  'enable',
  'code',
  'companyName'
] as const

/** 車種 */

export type TruckModelsSortKey = NonNullable<
  NonNullable<TruckModelsListRequestQuery>['sort']
>

export const TRUCK_MODELS_SORT_KEYS: TruckModelsSortKey[] = [
  'code',
  'name',
  'chargeTypeName',
  'enable'
]

/** 車両 */
export type TruckSortKey = NonNullable<NonNullable<TrucksRequestQuery>['sort']>

export const TRUCKS_SORT_KEYS: TruckSortKey[] = [
  'truckName',
  'truckCode',
  'truckClass',
  'truckType',
  'partner',
  'subPartner'
] as const

/** ドライバー */

export type DriverUsersSortKey = NonNullable<
  NonNullable<DriverUsersListRequestQuery>['sort']
>

export const DRIVER_USERS_SORT_KEYS: DriverUsersSortKey[] = [
  'name',
  'subPartner',
  'phoneNumber',
  'enable'
]

/** 運送会社 */
export type SubPartnersSortKey = NonNullable<
  NonNullable<SubPartnersRequestQuery>['sort']
>

export const SUB_PARTNERS_SORT_KEYS: SubPartnersSortKey[] = ['name', 'enable']

/** 地点 */
export type SitesSortKey = NonNullable<
  NonNullable<SitesListRequestQuery>['sort']
>

export const SITES_SORT_KEYS: SitesSortKey[] = [
  'siteCode',
  'siteName',
  'displayNameMiddle',
  'displayNameShort',
  'location',
  'note',
  'updatedAt'
] as const

/** 荷主 */
export type CustomersSortKey = NonNullable<
  NonNullable<CustomersListRequestQuery>['sort']
>

export const CUSTOMERS_SORT_KEYS: CustomersSortKey[] = [
  'customerCode',
  'customerName',
  'enable'
]

/** 荷姿 */
export type PackageCategoriesSortKey = NonNullable<
  NonNullable<PackageCategoriesListRequestQuery>['sort']
>

export const PACKAGE_CATEGORIES_SORT_KEYS: PackageCategoriesSortKey[] = [
  'code',
  'name',
  'shortName',
  'enable'
]

/** 配送種別 */

export type ShipmentCategoriesSortKey = NonNullable<
  NonNullable<ShipmentCategoriesListRequestQuery>['sort']
>

export const SHIPMENT_CATEGORIES_SORT_KEYS: ShipmentCategoriesSortKey[] = [
  'code',
  'name',
  'displayColor',
  'enable'
]

/** 支払契約 */
export type ContractsSortKey = NonNullable<
  NonNullable<ContractsRequestQuery>['sort']
>

export const CONTRACTS_SORT_KEYS: ContractsSortKey[] = [
  'contractName',
  'partner',
  'contractType',
  'startAt',
  'contractTariff',
  'contractTariffType'
]

/** 請求契約 */
export type CustomerContractsSortKey = NonNullable<
  NonNullable<CustomerContractsRequestQuery>['sort']
>

export const CUSTOMER_CONTRACTS_SORT_KEYS: CustomerContractsSortKey[] = [
  'contractNumber',
  'contractName',
  'contractCustomer',
  'startAt',
  'endAt',
  'contractTariff',
  'contractTariffType',
  'contractTariffEdition',
  'contractCalcRuleName',
  'updatedAt',
  'updatedUser'
]
/** タリフ */
// タリフインポート一覧のソートは未実装

// システムマスタ設定のソートキー一覧

/** 拠点ユーザー */
export type DcUsersSortKey = NonNullable<
  NonNullable<DcUsersRequestQuery>['sort']
>

export const DC_USERS_SORT_KEYS: DcUsersSortKey[] = [
  'displayName',
  'email',
  'enable'
  // 'dc' --- 'dc'はAPI側でソート不可のため除外
]

/** パートナーユーザー */
export type PartnerUsersSortKey = NonNullable<
  NonNullable<PartnerUsersRequestQuery>['sort']
>

export const PARTNER_USERS_SORT_KEYS: PartnerUsersSortKey[] = [
  'displayName',
  'email',
  'enable'
]

/** エリア */
export type AreasSortKey = NonNullable<
  NonNullable<AreasListRequestQuery>['sort']
>

export const AREAS_SORT_KEYS: AreasSortKey[] = [
  'areaCode',
  'areaName',
  'updatedAt'
]
/** 車格 */
export type TruckClassesSortKey = NonNullable<
  NonNullable<TruckClassesRequestQuery>['sort']
>

export const TRUCK_CLASSES_SORT_KEYS: TruckClassesSortKey[] = [
  'code',
  'name',
  'chargeTypeName',
  'enable'
]

/** 車両属性 */
export type TruckTypesSortKey = NonNullable<
  NonNullable<TruckTypesRequestQuery>['sort']
>

export const TRUCK_TYPES_SORT_KEYS: TruckTypesSortKey[] = [
  'code',
  'name',
  'enable'
]

/** 追加運賃項目 */
export type AdditionalPaymentCategoriesSortKey = NonNullable<
  NonNullable<AdditionalPaymentCategoriesRequestQuery>['sort']
>

export const ADDITIONAL_PAYMENT_CATEGORIES_SORT_KEYS: AdditionalPaymentCategoriesSortKey[] =
  [
    'name',
    'isActive',
    'reportType',
    'isDefaultDisplayed',
    'taxType',
    'roundType'
  ]
/** 個建契約単位 */
export type ItemUnitsSortKey = NonNullable<
  NonNullable<ItemUnitsRequestQuery>['sort']
>

export const ITEM_UNITS_SORT_KEYS: ItemUnitsSortKey[] = ['name', 'enable']
/** 運賃種別 */
export type ChargeTypesSortKey = NonNullable<
  NonNullable<ChargeTypesRequestQuery>['sort']
>

export const CHARGE_TYPES_SORT_KEYS: ChargeTypesSortKey[] = ['name', 'enable']
